import dotenv from 'dotenv';
dotenv.config();

export const backend_url = 'https://slsa-api.quoteshark.co/api/v1';
